import { css } from "styled-components";

export const cardStyles = css`
  border-radius: 10px;
  background-color: rgba(249, 232, 204, 0.7);
  color: #343f56;
  /* box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.2); */
`;
